<template>
  <!-- 在线月度分析报告 -->
  <div class="analysisReport">
    <!-- <el-button type="primary" class="export" @click="downloadPage('pdfPrint',header.zykNum,header.zykName)">导出</el-button> -->
    <!-- <el-button class="export" type="primary" size="small" @click="toImage">生成PDF</el-button> -->
    <div class="analysisReport_box" id="pdfPrint">
      <div class="header_titles">
        <h1>国家职业教育智慧教育平台专业与课程服务中心</h1>
        <h1>2022年第3季度运行数据分析报告</h1>
        <div class="number_time">
          <div>
            <span></span>
            <span>统计时间：2022-07-01 至 2022-09-30</span>
          </div>
          <p></p>
          <p></p>
        </div>
      </div>

      <div class="chart_box">
        <h1>1. 监测总览</h1>
        <p>
          截至2022年6月30日，职业教育专业教学资源库已立项建设项目共计{{
            dataAll.dataList.zykNum
          }}个，其中国家级资源库共计{{ resourceLevel.countryNum.value }}个，省级资源库共计{{
            resourceLevel.provinceNum.value
          }}个，校级资源库共计{{ resourceLevel.schoolNum.value }}个，覆盖了{{
            getmajor.dataList.length
          }}专业大类。目前，已有{{ dataAll.dataList.schoolNum }}余所职业院校和{{
            dataAll.dataList.companyNum
          }}余家行业企业参与建设； 标准课程总量已达{{ getcourse.Standardization.value }}门
          ，资源库项目资源总量达{{
            (typeResources.sucai.value / 10000).toFixed(2) + "万"
          }}余条，资源库共有注册用户{{ (zykUserNum.total / 10000).toFixed(2) }}万余人，总访问量{{
            (dataAll.dataList.totalVisitNum / 100000000).toFixed(2)
          }}亿次，初步形成了国家、省、学校三级互补的优质资源共建共享体系，有力地推动了信息技术在职业教育专业教学和职业培训领域综合应用。具体建设应用情况如下：
        </p>
        <div style="height: 40px"></div>
        <!-- 1.1. 总体建设及应用分析 -->
        <div class="chart_box">
          <h2>1.1. 用户建设及应用情况</h2>
          <!-- 1.1.1. 用户建设及应用 -->
          <div class="chart_box">
            <p>
              当前，资源库共有注册用户{{
                (zykUserNum.total / 10000).toFixed(2)
              }}余人，按用户身份类型统计，教师{{ zykUserNum.teacher.value }}余人，学生{{
                (zykUserNum.student.value / 10000).toFixed(2) + "万"
              }}余人。资源库企业用户{{ zykUserNum.enterprise.value }}余人
              ，能够建设较好地考虑了企业员工继续教育、技能提升的需求，合作企业实现了依托资源库开展员工继续教育培训；资源库共有社会学习者用户{{
                zykUserNum.social.value
              }}余人，努力承担面向普通劳动者免费线上培训的社会责任
            </p>
            <p>
              资源库项目整体用户访问资源总量约{{
                VisitAll.resource > 100000000
                  ? (VisitAll.resource / 100000000).toFixed(2) + "亿"
                  : VisitAll.resource
              }}次、用户访问课程总量约{{
                VisitAll.course > 100000000
                  ? (VisitAll.course / 100000000).toFixed(2) + "亿"
                  : VisitAll.course
              }}次，用户互动交流次数约{{
                VisitAll.user > 100000000
                  ? (VisitAll.user / 100000000).toFixed(2) + "亿"
                  : VisitAll.user
              }}次。分布详情如下所示：
            </p>

            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'typeDistributionChart'"
                :datas="zykUserNum.dataList"
                :colorName="3"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 1 用户整体情况</div>

            <div class="standards_content echartsHeight">
              <circularChart
                :refId="'typeDistributionChart'"
                :datas="studentConstruction.dataList"
                :colorName="1"
                :innerText="'数量'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></circularChart>
            </div>
            <div class="chart_name">图 2 学生类型整体情况</div>
            <!-- 图 2 学生类型整体情况 -->
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'userTalk'"
                :datas="teaAstudVisit.dataList"
                :transverseData="teaAstudVisit.transverseData"
                :colorList="teaAstudVisit.colorList"
                :innerText="'单位：次'"
                :legendList="teaAstudVisit.legendList"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></discountChart>
            </div>
            <div class="chart_name">图 3 最近一年教师和学生访问情况</div>

            <!-- 图 4 最近一年社会学习者和企业用户访问情况 -->
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'userTalk'"
                :datas="enterAsoci.dataList"
                :transverseData="enterAsoci.transverseData"
                :colorList="enterAsoci.colorList"
                :innerText="'单位：次'"
                :legendList="enterAsoci.legendList"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></discountChart>
            </div>
            <div class="chart_name">图 4 最近一年社会学习者和企业用户访问情况</div>
          </div>
        </div>

        <!-- 1.2. 各省市建设及应用情况分析 -->
        <div class="chart_box">
          <h2>1.2. 课程建设及应用情况</h2>
          <div class="chart_box">
            <p>
              当前，资源库项目课程总量达到{{
                getcourse.total > 10000
                  ? (getcourse.total / 10000).toFixed(2) + "万"
                  : getcourse.total
              }}门，其中{{ getcourse.individualization.name
              }}{{
                getcourse.individualization.value > 10000
                  ? (getcourse.individualization.value / 10000).toFixed(2) + "万"
                  : getcourse.individualization.value
              }}门，{{ getcourse.Standardization.name }}{{ getcourse.Standardization.value }}门。
              课程访问日均次数{{
                VisitAll.course > 10000
                  ? (VisitAll.course / 1000000000).toFixed(2) + "亿"
                  : VisitAll.course
              }}次，其中，注册学生用户访问最多的课程是《{{ courseDataAll.name }}》，属于{{
                courseDataAll.zykName
              }}资源库。在94%的资源库中，项目课程(标准化课程)数量超过10门，课程按类型分布详情如下：
            </p>
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'resourcesMonthChart'"
                :datas="getcourse.dataList"
                :transverseData="getcourse.transverseData"
                :colorList="getcourse.colorList"
              ></tcolumnarChart>
            </div>
            <div class="chart_name">图 5 课程整体情况(单位：门)</div>

            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'userTalk'"
                :datas="courseVisit.dataList"
                :transverseData="courseVisit.transverseData"
                :colorList="courseVisit.colorList"
                :innerText="'单位：次'"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图 6 最近一年课程访问情况</div>
          </div>
        </div>

        <!-- 1.3. 2022-01-01至2022-06-30整体运行情况分析 -->
        <div class="chart_box">
          <h2>1.3 资源建设及应用情况</h2>
          <!-- 1.3.1. 用户运行情况 -->
          <div class="chart_box">
            <p>
              资源库项目资源数量达{{
                (typeResources.sucai.value / 10000).toFixed(4) + "万"
              }}余条，资源总容量达{{ typeResources.rongliang.value }}TB，{{
                educationLevel.Max.name
              }}资源数量最多，达到{{
                (educationLevel.Max.value / 10000).toFixed(4) + "万"
              }}个。除此之外，各资源库项目还开发了大量的实践教学资源，拥有{{
                educationLevel.xuni.value
              }}个虚拟仿真资源。资源访问总量已达{{
                (VisitAll.resource / 100000000).toFixed(2) + "亿"
              }}余次，日均访问资源{{ (VisitAll.resource / 365 / 10000).toFixed(2) + "万" }}次；
              其中访问次数最多的资源是“{{ resourceTable.Max.resourceType }}”，属于“{{
                resourceTable.Max.zykName
              }}”。
            </p>
            <!--图6 资源整体情况(单位：条) -->
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'resourcesMonthChart'"
                :datas="educationLevel.dataList"
                :transverseData="educationLevel.transverseData"
                :colorList="educationLevel.colorList"
              ></tcolumnarChart>
            </div>
            <div class="chart_name">图 7 资源整体情况(单位：条)</div>

            <div class="chart_box">
              <!--图6 资源整体情况(单位：条) -->
              <div class="standards_content echartsHeight">
                <discountChart
                  :refId="'userTalk'"
                  :datas="resource.dataList"
                  :transverseData="resource.transverseData"
                  :colorList="resource.colorList"
                  :innerText="'单位：次'"
                  :titleLeft="'32%'"
                  :legendBackgroundColor="true"
                  :legendLeft="'60%'"
                  :circleSize="80"
                  :isaverage="true"
                ></discountChart>
              </div>
              <div class="chart_name">图 8 最近一年资源访问情况</div>
            </div>
          </div>
        </div>

        <div class="chart_box">
          <h2>1.4. 国家级资源库应用情况分析</h2>
          <!-- 1.3.1. 用户运行情况 -->
          <div class="chart_box">
            <p>（1）覆盖专业大类分析</p>
            <p>
              截止到2022年9月30日，资源库覆盖{{
                getmajor.dataList.length
              }}个专业大类。从专业大类分布看，“所属{{ getmajor.MaxArr.name }}”的资源库最多，占比达{{
                ((getmajor.MaxArr.value / this.getmajor.total) * 100).toFixed(2)
              }}%，具体分布如下图所示：
            </p>

            <!--图6 资源整体情况(单位：条) -->
            <div class="chart_box">
              <div class="standards_content echartsHeight">
                <circularChart
                  :refId="'typeDistributionChart'"
                  :datas="getmajor.dataList"
                  :colorName="1"
                  :innerText="'数量'"
                  :legendBackgroundColor="true"
                  :circleSize="80"
                ></circularChart>
              </div>
              <div class="chart_name">
                图 9 资源库专业大类分布情况（只分析已关联专业大类的数据）
              </div>
            </div>
          </div>

          <div class="chart_box">
            <p>（2）按照访问量排名</p>
            <p>
              资源库项目中，“{{ getzykTable.FristArr.zykName }}资源库”的访问量最多，紧随其后的是“{{
                getzykTable.SecArr.zykName
              }}资源库”和“{{
                getzykTable.ThrArr.zykName
              }}资源库”。具体按照访问情况排名（前十五名）如下表所示：
            </p>
            <!--图6 资源整体情况(单位：条) -->
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>资源库名称</th>
                  <th>第一主持院校</th>
                  <th>课程数（门）</th>
                  <th>资源数（个）</th>
                  <th>访问量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in getzykTable.dataList"
                  :key="index"
                  v-show="getzykTable.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.zykName }}</td>
                  <td>{{ item.schoolName }}</td>
                  <td>{{ item.courseNum }}</td>
                  <td>{{ item.resourceCount }}</td>
                  <td>{{ item.logNum }}</td>
                </tr>

                <tr v-show="getzykTable.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 1 课程被访问量排名（前十五名）</div>
          </div>

          <div class="chart_box">
            <p>（3）按照用户活跃情况分析</p>
            <p>
              资源库项目中，“{{ getzykACtive.Frist.name }}资源库”的活跃用户数最多，紧随其后的是“{{
                getzykACtive.Second.name
              }}资源库”和“{{ getzykACtive.Thrid.name }}资源库”。
            </p>
            <!--图6 资源整体情况(单位：条) -->
            <div class="standards_content echartsHeight">
              <tcolumnarChart
                :refId="'resourcesMonthChart'"
                :datas="getzykACtive.dataList"
                :transverseData="getzykACtive.transverseData"
                :colorList="getzykACtive.colorList"
              ></tcolumnarChart>
            </div>
            <div class="chart_name">图 10 资源库活跃用户排名情况（前十五名）</div>
          </div>
        </div>
      </div>

      <!-- 2.1. 各省利用资源库进行教学的情况概览 -->
      <div class="chart_box">
        <h1>2. 各省利用资源库开展教学总体情况</h1>
        <div class="chart_box">
          <h2>2.1. 资源库建设及应用情况</h2>
          <div class="chart_box">
            <p>
              截至2022年9月30日，注册用户总计{{
                zykUserNum.total > 10000
                  ? zykUserNum.total / 10000 + "万"
                  : zykUserNum.total + "万"
              }}，覆盖34个省份，其中注册用户最多的是{{ userProvince.MaxArr.province }}省，达{{
                userProvince.MaxArr.num
              }}个用户之多； 交流互动量次数累计{{
                VisitAll.user > 100000000
                  ? (VisitAll.user / 100000000).toFixed(2) + "亿"
                  : VisitAll.user
              }}次，互动交流频次最多的是{{ userProvince.from.province }}省，{{
                (userProvince.from.num / 10000).toFixed(2) + "万"
              }}次；在线学习总人数{{
                (userProvince.studyTotal / 10000).toFixed(2) + "万"
              }}，在线学习人数最多的则是{{ userProvince.MaxArr.province }}省。共{{
                userProvince.onilneMax.activeNum > 10000
                  ? (userProvince.onilneMax.activeNum / 10000).toFixed(2) + "万"
                  : userProvince.onilneMax.activeNum
              }}人。 资源库中各省份应用情况排名（前十五名）如下表所示：
            </p>

            <div class="chart_box">
              <div class="biaoge">
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  width="100%"
                  bordercolor="#fff"
                  class="course"
                >
                  <tr>
                    <th>排名</th>
                    <th>省份</th>
                    <th>资源库数（个）</th>
                    <th>注册用户数（个）</th>
                    <th>在线学习数（人）</th>
                    <th>交流互动量（次）</th>
                  </tr>

                  <tr
                    v-for="(item, index) in userProvince.dataList"
                    :key="index"
                    v-show="userProvince.dataList.length > 0"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.province }}</td>
                    <td>{{ item.zykCount }}</td>
                    <td>{{ item.num }}</td>
                    <td>{{ item.activeNum }}</td>
                    <td>{{ item.formun }}</td>
                  </tr>
                  <tr v-show="userProvince.dataList.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 2 资源库中各省份应用情况排名（前十五名）</div>
            </div>

            <div class="standards_content echartsHeight" style="height: 700px">
              <distributionChart
                :refId="'userTalk'"
                :datas="userProvince.mapdatas"
                :color="userProvince.mapcolorList"
              ></distributionChart>
            </div>
            <div class="chart_name">图 11 各省用户访问资源库分布</div>
          </div>
        </div>

        <div class="chart_box">
          <h2>2.2. 各省课程建设及应用</h2>
          <div class="chart_box">
            <p>
              截至2022年9月30日，资源库建设课程总计{{
                dataAll.courseTotal > 10000
                  ? (dataAll.courseTotal / 10000).toFixed(3) + "万"
                  : dataAll.courseTotal
              }}门，覆盖34个省份，其中建设课程数量最多的是{{
                curriculum.MaxArr.value
              }}门；标准课程数累计有{{ getcourse.Standardization.value }}门， 标准课程数最多的属于{{
                curriculProvince.standard.name
              }}，共{{ curriculProvince.standard.snum }}门，个性化课程数累计有{{
                getcourse.individualization.name
              }}{{
                getcourse.individualization.value > 10000
                  ? (getcourse.individualization.value / 10000).toFixed(2) + "万"
                  : getcourse.individualization.value
              }}门，个性化课程数最多的是{{ curriculProvince.personality.name }}，{{
                curriculProvince.personality.pnum
              }}门。 具体各省资源库课程建设按照总课程数排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <th>标准化课程数</th>
                  <th>个性化课程数</th>
                  <th>总课程数（门）</th>
                </tr>

                <tr
                  v-for="(item, index) in curriculProvince.dataList"
                  :key="index"
                  v-show="curriculProvince.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.snum }}</td>
                  <td>{{ item.pnum }}</td>
                  <td>{{ item.num }}</td>
                </tr>

                <tr v-show="curriculProvince.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 3 各省资源库课程按照课程总量排名（前十五名）</div>
          </div>
        </div>

        <div class="chart_box">
          <h2>2.3. 各省资源建设及应用</h2>
          <p>
            截至2022年6月30日，建设资源库资源累计达{{
              typeResources.sucai.value > 10000
                ? (typeResources.sucai.value / 10000).toFixed(2) + "万"
                : typeResources.sucai.value
            }}个，覆盖34个省份， 其中建设资源数量最多的是{{ disksNum.buildMax.province1 }}省，有{{
              (disksNum.buildMax.log / 10000).toFixed(2) + "万"
            }}个。各省访问资源的总量达{{
              VisitAll.resource > 100000000
                ? (VisitAll.resource / 100000000).toFixed(2) + "亿"
                : VisitAll.resource
            }}次， 访问资源总量最多的是{{
              disksNum.MaxArr.province1
            }}省。具体各省资源库资源建设按照访问量情况排名（前十五名）如下表所示：
          </p>
          <div class="chart_box">
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>省份</th>
                  <th>资源数（条）</th>
                  <th>资源量（TB）</th>
                  <th>访问量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in disksNum.dataList"
                  :key="index"
                  v-show="disksNum.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.province1 }}</td>
                  <td>{{ item.count }}</td>
                  <td>{{ item.disksNum.toFixed(2) }}</td>
                  <td>{{ item.log }}</td>
                </tr>

                <tr v-show="disksNum.dataList.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 4 各省资源库资源访问量情况排名（前十五名）</div>
          </div>
        </div>
      </div>

      <div class="chart_box">
        <h1>3. 2022-01-01至2022-06-30资源库运行情况分析</h1>
        <div class="chart_box">
          <h2>3.1. 资源库用户运行情况</h2>
          <div class="chart_box">
            <p>（1）资源库用户月活情况分析</p>
            <p>
              在该时间段内，资源库月活共{{
                (zykuserYun.userActiveTotals / 10000).toFixed(2) + "万"
              }}次，平均月活{{
                (zykuserYun.userActiveTotals / 3 / 10000).toFixed(2) + "万"
              }}次。月活趋势如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'resourcesMonthChart'"
                :datas="zykuserYun.userActiveData"
                :transverseData="zykuserYun.userActiveTranserve"
                :colorList="zykuserYun.colorList"
                :colorName="1"
                :innerText="'单位：门'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图 12 2022-07-01至2022-09-30资源库月活趋势</div>
          </div>

          <div class="chart_box">
            <p>（2）资源库用户访问情况分析</p>
            <p>
              在该时间段内，资源库项目中累计活跃用户{{ zykuserYun.userActiveTotal }}人，累计点击{{
                (zykuserYun.userActivelogNum / 100000000).toFixed(2) + "亿"
              }}次。其中，{{ zykuserYun.roleStudent.role }}活跃用户{{
                zykuserYun.roleStudent.num
              }}人，累计访问共{{ (zykuserYun.roleStudent.logNum / 10000).toFixed(2) + "万" }}次；{{
                zykuserYun.roleTeacher.role
              }}活跃用户{{ (zykuserYun.roleTeacher.num / 10000).toFixed(2) + "万" }}人
              ，累计访问共{{
                (zykuserYun.roleTeacher.logNum / 10000).toFixed(2) + "万"
              }}次；企业员工{{ zykuserYun.roleEnterprise.num }}人，累计访问{{
                (zykuserYun.roleEnterprise.logNum / 10000).toFixed(2) + "万"
              }}次； 社会学习者{{ zykuserYun.roleSocial.num }}人， 累计访问资源库{{
                (zykuserYun.roleSocial.logNum / 10000).toFixed(2) + "万"
              }}次。各类型用户访问趋势图如下：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'userTalk'"
                :datas="zykuserYun.userActiveRoleData"
                :transverseData="zykuserYun.userActiveRoleTranserve"
                :colorList="zykuserYun.colorList"
                :innerText="'单位：次'"
                :legendList="zykuserYun.userActiveRolelegendList"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></discountChart>
            </div>
            <div class="chart_name">图 13 2022-07-01至2022-09-30资源库月活趋势</div>
          </div>

          <div class="chart_box">
            <p>（3）资源库用户新增情况分析</p>
            <p>
              在该时间段内，学生用户新增共{{
                (userAdd.Stotal / 10000).toFixed(2) + "万"
              }}名，教师用户新增共{{ userAdd.Ttotal }}名。师生新增情况如下所示：
            </p>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'userTalk'"
                :datas="userAdd.sAtdatas"
                :transverseData="userAdd.transverse"
                :colorList="userAdd.colorList"
                :innerText="'单位：次'"
                :legendList="userAdd.sAtlegendList"
                :titleLeft="'32%'"
                :legendBackgroundColor="true"
                :legendLeft="'60%'"
                :circleSize="80"
              ></discountChart>
            </div>
            <div class="chart_name">图 14 2022-07-01至2022-09-30资源库月活趋势</div>
          </div>

          <div class="chart_box">
            <p>（4）资源库被用户访问情况排名分析</p>
            <p>
              在该时间段内，被用户访问最多的资源库是{{ userTop.fristMax.projectTypeCn }}的“{{
                userTop.fristMax.zykName
              }}资源库”。具体被访问资源库排名（前十五名）和（前十五名）如下表所示：
            </p>
            <div class="chart_box">
              <div class="chart_box">
                <div class="biaoge">
                  <table
                    border="0"
                    cellpadding="0"
                    cellspacing="0"
                    width="100%"
                    bordercolor="#fff"
                    class="course"
                  >
                    <tr>
                      <th>排名</th>
                      <th>资源库名称</th>
                      <th>第一主持院校</th>
                      <th>级别</th>
                      <th>访问量（次）</th>
                    </tr>

                    <tr
                      v-for="(item, index) in userTop.fristTop15"
                      :key="index"
                      v-show="userTop.fristTop15.length > 0"
                    >
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.zykName }}</td>
                      <td>{{ item.firstChargeUnit }}</td>
                      <td>{{ item.projectTypeCn }}</td>
                      <td>{{ item.num }}</td>
                    </tr>
                    <tr v-show="userTop.fristTop15.length == 0" class="nothing">
                      <td colspan="6">无</td>
                    </tr>
                  </table>
                </div>
                <div class="chart_name">
                  表 5 2022-07-01至2022-09-30资源库访问量排行榜（前十五名）
                </div>
              </div>
            </div>

            <div class="chart_box">
              <div class="biaoge">
                <table
                  border="0"
                  cellpadding="0"
                  cellspacing="0"
                  width="100%"
                  bordercolor="#fff"
                  class="course"
                >
                  <tr>
                    <th>排名</th>
                    <th>资源库名称</th>
                    <th>第一主持院校</th>
                    <th>级别</th>
                    <th>访问量（次）</th>
                  </tr>

                  <tr
                    v-for="(item, index) in userTop.last15"
                    :key="index"
                    v-show="userTop.last15.length > 0"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.zykName }}</td>
                    <td>{{ item.firstChargeUnit }}</td>
                    <td>{{ item.projectTypeCn }}</td>
                    <td>{{ item.num }}</td>
                  </tr>
                  <tr v-show="userTop.last15.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">
                表 6 2022-07-01至2022-09-30资源库访问量排行榜（后十五名）
              </div>
            </div>
          </div>
        </div>

        <div class="chart_box">
          <h2>3.2. 资源库课程运行情况</h2>
          <!-- <p>在分析时间内，资源库新增课程数为N门，具体新增情况如下：</p> -->
          <div class="chart_box">
            <p>在分析时间内，资源库新增课程总数共{{ courseNew.total }}条，具体新增情况如下：</p>
            <div class="standards_content echartsHeight">
              <discountChart
                :refId="'resourcesMonthChart'"
                :datas="courseNew.dataList"
                :transverseData="courseNew.transverse"
                :colorList="courseNew.colorList"
                :colorName="1"
                :innerText="'单位：条'"
                :isaverage="true"
              ></discountChart>
            </div>
            <div class="chart_name">图 15 2022年7月01日至2022年9月30日资源库课程新增趋势</div>
          </div>

          <div class="chart_box">
            <p>
              据监测平台统计，截至2022年9月30日，被访问量居首的课程是《{{
                courseTalkTable.MaxArr.courseName
              }}》，有{{
                (courseTalkTable.MaxArr.courseTotalVisit / 10000).toFixed(2) + "万"
              }}次，具体课程按照访问量排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>课程名称</th>
                  <th style="width: 400px">课程来源</th>
                  <th>课程负责人</th>
                  <th>建设院校</th>
                  <th>访问量（次）</th>
                </tr>

                <tr
                  v-for="(item, index) in courseTalkTable.dataList"
                  :key="index"
                  v-show="courseTalkTable.dataList.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.courseName }}</td>
                  <td>{{ item.courseType }}</td>
                  <td>{{ item.majorTeacher }}</td>
                  <td>{{ item.schoolName }}</td>
                  <td>{{ item.courseTotalVisit }}</td>
                </tr>

                <tr v-show="courseTalkTable.dataList.length == 0" class="nothing">
                  <td colspan="6">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">
              表 7 2022-07-01至2022-09-30 资源库课程被访问量排名（前十五名）
            </div>
          </div>
        </div>

        <!-- 2.3.3. 资源库资源运行情况 -->
        <div class="chart_box">
          <h3>3.3. 资源库资源运行情况</h3>
          <div class="chart_box">
            <p>
              在分析时间内，资源库新增资源数为{{
                zyktalk.total
              }}条，具体资源库新增资源数排名（前十五名）情况如下：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>资源库</th>
                  <th>所属院校</th>
                  <th>级别</th>
                  <th>新增资源数</th>
                </tr>

                <tr
                  v-for="(item, index) in zyktalk.newRank"
                  :key="index"
                  v-show="zyktalk.newRank.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.zyk_name }}</td>
                  <td>{{ item.first_charge_unit }}</td>
                  <td>{{ item.project_type_cn }}</td>
                  <td>{{ item.num }}</td>
                </tr>
                <tr v-show="zyktalk.newRank.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 8 资源库按照新增的资源数排名（前十五名）</div>
          </div>

          <div class="chart_box">
            <p>
              在分析时间内，资源库资源被访问总量达{{
                (courseTrend.total / 100000000).toFixed(2) + "亿"
              }}次，其中，《{{
                zyktalk.MaxArr.zyk_name
              }}》资源库的资源数被访问的次数最多。资源库按照资源被访问量排名（前十五名）如下表所示：
            </p>
            <div class="biaoge">
              <table
                border="0"
                cellpadding="0"
                cellspacing="0"
                width="100%"
                bordercolor="#fff"
                class="course"
              >
                <tr>
                  <th>排名</th>
                  <th>资源库</th>
                  <th>所属院校</th>
                  <th>级别</th>
                  <th>资源访问量</th>
                </tr>

                <tr
                  v-for="(item, index) in zyktalk.logRank"
                  :key="index"
                  v-show="zyktalk.logRank.length > 0"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.zyk_name }}</td>
                  <td>{{ item.first_charge_unit }}</td>
                  <td>{{ item.project_type_cn }}</td>
                  <td>{{ item.num }}</td>
                </tr>
                <tr v-show="zyktalk.logRank.length == 0" class="nothing">
                  <td colspan="5">无</td>
                </tr>
              </table>
            </div>
            <div class="chart_name">表 9 资源库按照资源被访问量排名（前十五名）</div>
          </div>
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; // 引入竖柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import waterDropChart from "@/components/chart/waterDropChart.vue"; // 引入水滴图图表
import distributionChart from "@/components/chart/distributionChart.vue"; // 地图
export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart,
    distributionChart,
  },
  data() {
    return {
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], // 柱状图或折线图的颜色
      // 数据总览
      dataAll: {
        dataList: [],
        courseTotal: null,
      },
      // 资源等级
      resourceLevel: {
        dataList: [],
        countryNum: {},
        provinceNum: {},
        schoolNum: {},
      },

      // 资源库用户数
      zykUserNum: {
        dataList: [],
        total: null,
        teacher: {},
        student: {},
        enterprise: {},
        social: {},
        other: {},
      },

      // 总访问量
      VisitAll: {
        resource: {},
        course: {},
      },

      // 学生类型整体情况
      studentConstruction: {
        dataList: [],
      },
      // 学生 + 老师 近一年访问情况
      teaAstudVisit: {
        dataList: [],
        colorList: [],
        legendList: [],
        transverseData: [],
      },
      // 企业用户 + 社会学习者 近一年访问情况
      enterAsoci: {
        dataList: [],
        colorList: [],
        legendList: [],
        transverseData: [],
      },
      // 课程画像-课程数量图
      getcourse: {
        total: null,
        individualization: {},
        Standardization: {},
        dataList: [],
        transverseData: [],
        colorList: [],
      },

      // 课程整体情况
      courseDataAll: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 近一年课程访问趋势
      courseVisit: {
        dataList: [],
        transverseData: [],
        colorList: [],
      },
      // 近一年资源访问趋势
      resource: {
        dataList: [],
        transverseData: [],
        colorList: [],
      },

      // 各类型资源存储量
      typeResources: {
        dataList: [],
        sucai: {},
        rongliang: {},
      },
      // 各类视频资源
      educationLevel: {
        dataList: [],
        colorList: [],
        transverseData: [],
        Max: {},
        xuni: {},
      },
      // 资源被访问量排名前十五
      resourceTable: {
        MaxArr: [],
        Max: {},
        MaxZykname: {},
        resourceAvg: null,
        resourceTotal: null,
      },
      // 国家专业大类
      getmajor: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 资源库访问量排名
      getzykTable: {
        dataList: [],
        transverseData: [],
        colorList: [],
        datas: [],
        FristArr: {},
        SecArr: {},
        ThrArr: {},
      },
      // 活跃用户数排名
      getzykACtive: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {},
        Second: {},
        Thrid: {},
      },
      // 各省交流互动量排名（前十五名）
      userProvince: {
        dataList: [],
        from: {},
        studentUser: {},
        mapdatas: [],
        mapcolorList: ["#ffd9d9"],
        MaxArr: [],
        onilneMax: {},
        total: null,
        talkTotal: null,
        studyTotal: null,
      },
      // 课程数量分布
      curriculum: {
        dataList: [],
        legendList: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#E8FF6C", "#00EEF2", "#0DA1FD", "#F50512"],
        sortMax: [],
        MaxArr: [],
        total: null,
      },

      // 各省课程建设及应用
      curriculProvince: {
        dataList: [],
        MaxArr: [],
        SerArr: [],
        total: null,
        stotal: null, // 标准化课程总数
        ptotal: null, // 个性化课程总数
        standard: {},
        personality: {},
      },

      // 资源库省份资源建设情况
      disksNum: {
        total: null,
        totalLog: null,
        dataList: [],
        MaxArr: [],
        buildMaxArr: [],
        buildMax: {},
        maxProvince: {},
      },

      // 资源库用户运行情况
      zykuserYun: {
        // 资源库用户月活情况分析
        userActiveTotal: null,
        userActiveData: [],
        userActiveTranserve: [],
        userActiveTotals: null,

        userActivelogNum: null,
        userActiveRoleData: [],
        userActiveRoleTranserve: [],
        userActiveRolelegendList: [],

        roleStudent: {},
        roleTeacher: {},
        roleEnterprise: {},
        roleSocial: {},

        userActiveMonthTransverseData: [],
        userActiveMonthDataList: [],
      },
      // 获取区间内每月新增用户数
      userAdd: {
        dataList: [],
        sAtdatas: [],
        Stotal: null,
        Ttotal: null,
        sAtlegendList: ["学生", "教师"],
        legendList: ["学生", "教师", "社会学习者", "企业用户"],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      // 访问情况排名(前十五、后十五)
      userTop: {
        fristTop15: [],
        fristMax: [],
        last15: [],
        lastMax: [],
      },
      // 新增课程数
      courseNew: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      // 课程访问量排名
      courseTalkTable: {
        dataList: [],
        MaxArr: [],
        total: null,
      },

      // 资源库资源运行情况 （新增资源数） +（资源访问量）
      zyktalk: {
        total: null,
        totalLog: null,
        newRank: [],
        logRank: [],
        MaxArr: [],
      },

      // 课程访问量
      courseTrend: {
        dataList: [],
        transverse: [],
        colorList: ["#3B85FB", "#FD398E", "#04F995", "#00EEF2", "#E8FF6C", "#0DA1FD", "#F50512"],
        total: null,
      },
      loading: "", // 是否导出加载中
    };
  },
  created() {
    if (this.$route.query) {
    }
    // 1. 监测总览
    this.dataAllHandler(); //       获取所有的国家数据总览
    this.resourceLevelHandler(); //       国家资源库个数

    this.zykUserNumHandler(); //       资源库用户数
    this.VisitAllHandler(); //       访问总体情况
    this.studentConstructionHandler(); //       学生类型整体情况
    this.visitUserHandler(); //       近一年用户访问情况（学生 + 老师 + 社会学习者 + 企业用户）

    this.getcourseHandler(); //       课程画像-课程数量图
    this.courseAllHandler(); //       课程整体情况
    this.courseVisitHanderl(); //       近一年课程访问趋势

    this.resourcesrHandler(); //       资源素材数和储存容量
    this.resourcesProportion(); //       各类视频资源
    this.resourceTableHandler(); //       资源被访问量排名前十五
    this.getmajorHandler(); //       国家专业大类

    this.getzykHandler(); //       资源库访问量排名
    this.getzykACtiveHandler(); //       资源库活跃用户数排名

    this.getuserProHandeler(); //       各省资源库累计
    this.curriculumNumHandler(); //       课程数量分布
    this.curriculProvinceHandler(); //       资源库课程介绍
    this.disksNumHandler(); //       资源库省份资源建设情况

    this.zykuserYunHandler(); //       资源库用户运行情况
    this.userAddHanderl(); //       每月新增用户数
    this.fristAlast(); //       资源库被用户访问情况排名分析

    this.courseNewHandler(); //       新增课程数量
    this.courseTalkTableHandler(); //       课程访问量排名
    this.zyktalkHandler(); //       资源库资源运行情况
  },

  methods: {
    // 导出月报
    toImage() {
      this.loading = this.$loading({
        lock: true,
        text: "正在导出中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      this.$axios
        .post(
          this.$apiurls.exportMonthReport,
          {
            courseName: "",
            isAll: false,
            month: this.yearAndMonthly,
            reportType: 0,
            zykId: sessionStorage.getItem("zykId"),
            zykName: this.header.zykName,
            zykNum: this.header.zykNum,
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            window.open(res.data);
            this.loading.close();
          }
        })
        .catch(() => {
          this.loading.close();
        });
    },

    // 获取所有的数据总览
    dataAllHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportOverview, {
          loading: false,
        })
        .then((res) => {
          this.dataAll.dataList = res.data;

          let datas = [];
          datas.push(
            {
              name: "资源库课程数",
              value: res.data.courseNum,
            },
            {
              name: "在线精品课数",
              value: res.data.onlineCourseNum,
            },
            {
              name: "视频公开课",
              value: res.data.videoCourseNum,
            }
          );

          // 资源库课程总数
          datas.forEach((item) => {
            this.dataAll.courseTotal += item.value;
          });
        });
    },

    // 资源库个数
    resourceLevelHandler() {
      this.$axios
        .post(this.$apiurls.resourceBaseMonitoringCloudMap_getResourceBaseLevel, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            for (let i = 0; i < res.data.dataList.length; i++) {
              this.resourceLevel.dataList.push({
                name: res.data.transverseData[i],
                value: res.data.dataList[i],
              });
            }
            this.resourceLevel.countryNum = this.resourceLevel.dataList.find(
              (item) => item.name == "国家级"
            );
            this.resourceLevel.provinceNum = this.resourceLevel.dataList.find(
              (item) => item.name == "省市级"
            );
            this.resourceLevel.schoolNum = this.resourceLevel.dataList.find(
              (item) => item.name == "院校级"
            );
          }
        });
    },

    // 资源库用户数
    zykUserNumHandler() {
      this.$axios
        .post(this.$apiurls.resourceBaseMonitoringCloudMap_getCoreIndicators, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let data = [];
            for (let i = 0; i < res.data.dataList.length; i++) {
              data.push({ name: res.data.transverseData[i], value: res.data.dataList[i] });
            }
            this.zykUserNum.teacher = data.find((item) => item.name == "教师数量");
            this.zykUserNum.student = data.find((item) => item.name == "学生数量");
            this.zykUserNum.enterprise = data.find((item) => item.name == "企业用户");
            this.zykUserNum.social = data.find((item) => item.name == "社会学习者");
            this.zykUserNum.other = data.find((item) => item.name == "其他");

            this.zykUserNum.dataList.push(
              this.zykUserNum.teacher,
              this.zykUserNum.student,
              this.zykUserNum.enterprise,
              this.zykUserNum.social,
              this.zykUserNum.other
            );
            this.zykUserNum.dataList.forEach((item) => {
              this.zykUserNum.total += item.value;
            });
          }
        });
    },

    // 访问总体情况
    VisitAllHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportTotalLogModule, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.VisitAll.resource = res.data.resource;
            this.VisitAll.course = res.data.course;
            this.VisitAll.user = res.data.user;
          }
        });
    },

    // 学生类型整体情况
    studentConstructionHandler() {
      this.$axios
        .post(this.$apiurls.userPortrait_getSumStudentTypeEchart, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.studentConstruction.dataList = res.data.map((item) => {
              let name = item.name;
              let value = item.value;
              return {
                name,
                value,
              };
            });
          }
        });
    },

    // 获取近一年用户访问情况
    visitUserHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportUserMonthVisits, {
          loading: false,
        })
        .then((res) => {
          // 老师 + 学生访问趋势
          this.teaAstudVisit.dataList.push(res.data.teacher.value, res.data.student.value);
          this.teaAstudVisit.legendList = ["老师", "学生"];
          this.teaAstudVisit.transverseData = res.data.teacher.name;
          this.teaAstudVisit.colorList = this.colorList;

          // 社会学习者 + 企业用户 访问量趋势
          let social = [];
          res.data.social.forEach((item) => {
            social.push(item.value);
          });

          let enterprise = [];
          res.data.enterprise.forEach((item) => {
            enterprise.push(item.value);
          });
          this.enterAsoci.dataList.push(social, enterprise);
          this.enterAsoci.legendList = ["社会学习者", "企业用户"];
          this.enterAsoci.transverseData = res.data.teacher.name;
          this.enterAsoci.colorList = this.colorList;
        });
    },

    // 课程画像 - 课程数量图
    getcourseHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getSumCourseTypeCountEchart, {
          loading: false,
        })
        .then((res) => {
          this.getcourse.Standardization = res.data.find((item) => item.name == "标准化课程");
          this.getcourse.individualization = res.data.find((item) => item.name == "个性化课程");
          this.getcourse.dataList = res.data.map((item, index) => {
            let name = item.name;
            let value = item.value;
            return {
              name,
              value,
            };
          });
          this.getcourse.total = res.data[0].value + res.data[1].value;
          this.getcourse.dataList.forEach((item) => {
            this.getcourse.transverseData.push(item.name);
          });

          this.getcourse.colorList = this.colorList;
        });
    },
    // 课程整体情况
    courseAllHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseState, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.courseDataAll.name = res.data.name;
            this.courseDataAll.zykDiv = res.data.zykDiv;
            this.courseDataAll.zykName = res.data.zykName;
          }
        });
    },
    // 近一年课程访问趋势
    courseVisitHanderl() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseMonthVisits, {
          loading: false,
        })
        .then((res) => {
          // 课程访问趋势
          this.courseVisit.dataList = res.data.course.value;
          this.courseVisit.transverseData = res.data.course.name;
          this.courseVisit.colorList = this.colorList;

          // 资源访问趋势
          this.resource.dataList = res.data.resource.value;
          this.resource.transverseData = res.data.resource.name;
          this.resource.colorList = this.colorList;
        });
    },

    // 资源素材数和储存容量
    resourcesrHandler() {
      this.$axios
        .post(this.$apiurls.monitoringCloud_getResourceCount, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.dataList.length; i++) {
            this.typeResources.dataList.push({
              name: res.data.transverseData[i],
              value: res.data.dataList[i],
            });
          }
          this.typeResources.sucai = this.typeResources.dataList.find(
            (item) => item.name == "素材资源"
          );
          this.typeResources.rongliang = this.typeResources.dataList.find(
            (item) => item.name == "资源存储量"
          );
        });
    },

    // 获取各资源素材类型占比情况
    resourcesProportion() {
      this.$axios
        .post(this.$apiurls.materialResources_getAllResourceCount, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let datas = [];
            for (let i = 0; i < res.data.name.length; i++) {
              datas.push({ name: res.data.name[i], value: res.data.value[i] });
            }
            datas = datas.filter((item) => item.name != "其他");
            console.log(datas);
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas.sort(Sort);

            datas.forEach((item) => {
              this.educationLevel.transverseData.push(item.name);
              this.educationLevel.dataList.push(item.value);
            });
            this.educationLevel.Max = datas[0];
            this.educationLevel.xuni = datas.find((item) => item.name == "虚拟仿真");
            this.educationLevel.colorList = this.colorList;
          }
        });
    },

    // 资源被访问量排名（前十五名）
    resourceTableHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportResourceRank, {
          loading: false,
        })
        .then((res) => {
          this.resourceTable.dataList = res.data.resourceRank;
          this.resourceTable.resourceTotal = res.data.resourceTotal;
          this.resourceTable.resourceAvg = res.data.resourceAvg;
          this.resourceTable.MaxArr = this.resourceTable.dataList;

          function Sort(a, b) {
            return b.num - a.num;
          }
          this.resourceTable.MaxArr.sort(Sort);
          this.resourceTable.Max = this.resourceTable.MaxArr[0];

          this.resourceTable.dataList.forEach((item) => {
            let index = item.name.indexOf(",") + 1;
            let type = item.name.slice(index);
            let name = item.name.slice(0, index - 1);
            this.$set(item, "resourceType", type);
            this.$set(item, "name", name);
          });

          let datasMax = this.educationLevel.Max;
          datasMax.name = datasMax.name + "类";
        });
    },

    // 国家专业大类
    getmajorHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykProfession, {
          loading: false,
        })
        .then((res) => {
          this.getmajor.dataList = res.data;
          this.getmajor.MaxArr = res.data[0];
          res.data.forEach((item) => {
            this.getmajor.total += item.value;
          });
        });
    },

    getzykHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykLogRank, {
          loading: false,
        })
        .then((res) => {
          this.getzykTable.dataList = res.data;
          this.getzykTable.FristArr = res.data[0];
          this.getzykTable.SecArr = res.data[1];
          this.getzykTable.ThrArr = res.data[2];

          let datas = res.data.map((item) => {
            let value = item.logNum;
            let name = item.zykName;
            return {
              value,
              name,
            };
          });

          function Sort(a, b) {
            return b.value - a.value;
          }
          datas.sort(Sort);
          datas.forEach((item) => {
            this.getzykTable.datas.push(item.value);
            this.getzykTable.transverseData.push(item.name);
          });
          this.getzykTable.colorList = this.colorList;
        });
    },

    // 获取资源库活跃用户数排名
    getzykACtiveHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykActiveUserRank, {
          loading: false,
        })
        .then((res) => {
          this.getzykACtive.colorList = this.colorList;
          res.data.forEach((item) => {
            this.getzykACtive.dataList.push(item.value);
            this.getzykACtive.transverseData.push(item.name);
          });
          this.getzykACtive.Frist = res.data[0];
          this.getzykACtive.Second = res.data[1];
          this.getzykACtive.Thrid = res.data[2];
        });
    },

    // 各省用户建设及应用情况
    getuserProHandeler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZykUserProvinceStatus, {
          loading: false,
        })
        .then((res) => {
          let datas = res.data.activeUser;

          function Sort(a, b) {
            return b.num - a.num;
          }
          datas.sort(Sort);

          this.userProvince.from = res.data.form;
          this.userProvince.studentUser = res.data.studentUser;
          this.userProvince.dataList = res.data.activeUser;

          res.data.activeUser.forEach((item) => {
            this.userProvince.total += item.num;
            this.userProvince.talkTotal += item.formun;
            this.userProvince.studyTotal += item.activeNum;
          });

          this.userProvince.MaxArr = res.data.studentUser;

          res.data.provinceLog.push(
            {
              name: "西藏",
              value: 0,
            },
            {
              name: "台湾",
              value: 0,
            },
            {
              name: "香港",
              value: 0,
            },
            {
              name: "青海",
              value: 0,
            },
            {
              name: "澳门",
              value: 0,
            }
          );
          this.userProvince.mapdatas = res.data.provinceLog;

          let onilneStudy = this.userProvince.dataList;
          function Sort(a, b) {
            return b.activeNum - a.activeNum;
          }
          onilneStudy.sort(Sort);
          this.userProvince.onilneMax = onilneStudy[0];
        });
    },

    // 课程数量分布
    curriculumNumHandler() {
      this.$axios
        .post(this.$apiurls.monitoringCloud_getSchoolCourseProvinceRanking, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.curriculum.dataList = res.data.dataList;
            this.curriculum.legendList = res.data.transverseData;
            let datas = [];
            for (let i = 0; i < this.curriculum.dataList.length; i++) {
              this.curriculum.total += this.curriculum.dataList[i];
              datas.push({
                name: this.curriculum.legendList[i],
                value: this.curriculum.dataList[i],
              });
            }
            // 数组排序
            function Sort(a, b) {
              return b.value - a.value;
            }
            datas.sort(Sort);
            this.curriculum.sortMax = datas;
            this.curriculum.MaxArr = this.curriculum.sortMax[0];
          }
        });
    },

    curriculProvinceHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZyKCourseProvinceStatus, {
          loading: false,
        })
        .then((res) => {
          this.curriculProvince.dataList = res.data.courseRank;
          this.curriculProvince.MaxArr = this.curriculProvince.dataList[0];
          this.curriculProvince.SerArr = this.curriculProvince.dataList[1];

          res.data.courseRank.forEach((item) => {
            this.curriculProvince.total += item.num;
            this.curriculProvince.stotal += item.snum;
            this.curriculProvince.ptotal += item.pnum;
          });
          res.data.standard = this.curriculProvince.dataList.find((item) => item.name == "湖南省");
          this.curriculProvince.standard = res.data.standard;

          res.data.personality = this.curriculProvince.dataList.find(
            (item) => item.name == "广东省"
          );
          this.curriculProvince.personality = res.data.personality;
        });
    },

    // 资源库省份建设情况
    disksNumHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportZyKResourceProvinceStatus, {
          loading: false,
        })
        .then((res) => {
          this.disksNum.maxProvince = res.data.maxProvince;
          this.disksNum.dataList = res.data.provinceRank;

          this.disksNum.MaxArr = this.disksNum.dataList[0];
          this.disksNum.dataList.forEach((item) => {
            this.disksNum.total += item.log;
            this.disksNum.totalLog += item.count;
          });

          this.disksNum.buildMaxArr = this.disksNum.dataList;

          function Sort(a, b) {
            return b.count - a.count;
          }

          this.disksNum.buildMaxArr.sort(Sort);
          this.disksNum.buildMax = this.disksNum.buildMaxArr[0];
        });
    },

    // 资源库用户运行情况
    zykuserYunHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKUserActiveStatus,
          {
            endDay: "2022-09-30",
            startDay: "2022-07-01",
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          // 累计活跃用户
          // （1）资源库用户月活情况分析
          this.zykuserYun.userActiveTotal = res.data.userActiveTotal;
          let datas1 = [];
          let datas2 = [];
          res.data.userActiveMonth.forEach((item) => {
            datas1.push(item.value);
            datas2.push(item.name);
            this.zykuserYun.userActiveTotals += item.value;
          });

          this.zykuserYun.userActiveData = datas1;
          this.zykuserYun.userActiveTranserve = datas2;

          // （2）资源库用户访问情况分析
          // 标题数据统计
          res.data.userActive.forEach((item) => {
            this.zykuserYun.userActivelogNum += item.logNum;
          });
          // 创建一个新数组
          let newRoleArr = res.data.userActive.map((item) => {
            let num = item.num;
            let logNum = item.logNum;
            let role = item.role;
            return {
              num,
              logNum,
              role,
            };
          });

          // 单独的每位用户数组
          this.zykuserYun.roleStudent = newRoleArr.find((item) => item.role == "学生");
          this.zykuserYun.roleTeacher = newRoleArr.find((item) => item.role == "教师");
          this.zykuserYun.roleEnterprise = newRoleArr.find((item) => item.role == "企业用户");
          this.zykuserYun.roleSocial = newRoleArr.find((item) => item.role == "社会学习者");

          this.zykuserYun.userActiveRoleData = res.data.userActiveMonthRole.dataList;
          this.zykuserYun.userActiveRoleTranserve = res.data.userActiveMonthRole.transverseData;
          this.zykuserYun.userActiveRolelegendList = res.data.userActiveMonthRole.legendList;
          this.zykuserYun.colorList = this.colorList;
        });
    },
    // 每月新增用户数
    userAddHanderl() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportUserMonthNew,
          { endDay: "2022-09-30", startDay: "2022-07-01" },
          {
            loading: false,
          }
        )
        .then((res) => {
          //  图13
          this.userAdd.transverse = res.data.enterprise.name;

          this.userAdd.dataList.push(
            res.data.student.value,
            res.data.teacher.value,
            res.data.enterprise.value,
            res.data.social.value
          );

          this.userAdd.colorList = this.colorList;
          let studentV = this.userAdd.dataList[0];
          let teacherV = this.userAdd.dataList[1];
          // 图 31
          this.userAdd.sAtdatas.push(studentV, teacherV);

          let enterpriseV = this.userAdd.dataList[2];
          let socialV = this.userAdd.dataList[3];
          let totalS = 0;
          let totalT = 0;
          let totalE = 0;
          let totalV = 0;

          studentV.forEach((item) => {
            this.userAdd.Stotal += item;
          });
          teacherV.forEach((item) => {
            this.userAdd.Ttotal += item;
          });

          enterpriseV.forEach((item) => {
            totalE += item;
          });

          socialV.forEach((item) => {
            totalV += item;
          });
          this.userAdd.total = totalS + totalT + totalE + totalV;
        });
    },
    // 资源库被用户访问情况排名分析
    fristAlast() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKVisitsRank,
          {
            endDay: "2022-09-30",
            startDay: "2022-07-01",
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.userTop.fristTop15 = res.data.slice(0, 15);
          this.userTop.fristMax = this.userTop.fristTop15[0];

          this.userTop.last15 = res.data.slice(-15);
          this.userTop.lastMax = this.userTop.last15[this.userTop.last15.length - 1];
          // 降级排序
          function Sort(a, b) {
            return a.num - b.num;
          }
          this.userTop.last15.sort(Sort);
        });
    },

    // 新增课程数
    courseNewHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportMonthRange,
          { endDay: "2022-09-30", startDay: "2022-07-01" },
          {
            loading: false,
          }
        )
        .then((res) => {
          if (res) {
            this.courseNew.dataList = res.data.courseNew.value;
            this.courseNew.transverse = res.data.courseNew.name;
            this.courseNew.dataList.forEach((item) => {
              this.courseNew.total += item;
            });

            // 课程访问量
            this.courseTrend.dataList = res.data.courseVisits.value;
            this.courseTrend.transverse = res.data.courseVisits.name;
            this.courseTrend.dataList.forEach((item) => {
              this.courseTrend.total += item;
            });
          }
        });
    },

    // 课程被访问量排名
    courseTalkTableHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseRank, {
          loading: false,
        })
        .then((res) => {
          this.courseTalkTable.dataList = res.data;
          this.courseTalkTable.dataList.forEach((item) => {
            this.courseTalkTable.total += item.courseTotalVisit;
          });

          function Sort(a, b) {
            return b.courseTotalVisit - a.courseTotalVisit;
          }
          this.courseTalkTable.dataList.sort(Sort);
          this.courseTalkTable.MaxArr = this.courseTalkTable.dataList[0];
        });
    },
    // 资源库资源运行情况
    zyktalkHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportZyKResourceStatus,
          {
            endDay: "2022-09-30",
            startDay: "2022-07-01",
          },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.zyktalk.total = res.data.total;
          this.zyktalk.totalLog = res.data.totalLog;
          this.zyktalk.newRank = res.data.newRank;
          this.zyktalk.logRank = res.data.logRank;

          function Sort(a, b) {
            return b.num - a.num;
          }

          this.zyktalk.logRank.sort(Sort);
          this.zyktalk.MaxArr = this.zyktalk.logRank[0];
        });
    },
  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  width: 70%;
  margin: 0px auto;
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 34px;
  font-weight: bold;
  color: #1d244e;
  line-height: 30px;
  margin-top: 10px;
}
.header_titles span {
  font-size: 20px;
  margin-top: 50px;
}
.header_titles .monthly {
  font-size: 18px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 20px 0px;
}
.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 17px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}
.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  width: 100%;
  height: 40px;
  position: relative;
  clear: both;
}
.division span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: #fff;
  font-weight: bold;
  font-size: 20px;
  color: #1d244e;
  font-size: 23px;
  padding: 0px 50px;
  line-height: 30px;
}

.chart_box {
  width: 100%;
  height: auto;
  margin-bottom: 60px;
  clear: both;
}

.chart_box h4 {
  font-weight: 700;
  font-size: 20px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 45px;
}
.chart_box p {
  font-size: 20px;
  text-indent: 40px;
  line-height: 45px;
  color: #707f9d;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 80%;
  height: calc(100vw / 1080 * 300);
  height: 400px;
  margin: 10px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 17px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 17px;
  color: #707f9d;
  clear: both;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 17px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
}

.center {
  text-align: center;
}
.divorced {
  margin-top: 40px;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
}
</style>

<style>
::-webkit-scrollbar {
  width: 10px !important;
  height: 14px;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important;
  border-radius: 3px;
}

.biaoge {
  width: 95%;
  margin: 0px auto 25px;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 35px;
  color: #707f9d;
  font-size: 15px;
}

.course tr:nth-child(2n) {
  background: #fff;
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: #7ed2ff;
  color: #566178;
}

.course tr:first-child {
  background: #66adff;
  color: #fff;
}

.chart_box {
  width: 100%;
  margin-bottom: 30px;
}
.chart_box h1 {
  font-size: 34px;
  margin-bottom: 50px;
}
.chart_box h2 {
  font-size: 28px;
  margin-bottom: 50px;
}
.chart_box h3 {
  font-size: 22px;
  margin-bottom: 50px;
}
.chart_box h4 {
  font-weight: 700;
  font-size: 18px;
  color: #1d244e;
  text-indent: 40px;
  line-height: 30px;
}
.chart_box p {
  font-size: 24px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}

.chart_box .echartsHeight {
  width: 80%;
  height: 380px;
  margin: 0px auto;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 17px;
  color: #707f9d;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 14px;
  color: #707f9d;
}

.creditRanking {
  display: flex;
  justify-content: space-between;
  font-size: 17px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}
</style>
